<template>
  <div class="filter-container" v-if="!rendering">
    <vue-horizontal class="scrollbar-container" ref="horizontal">
      <slot name="content"></slot>
      <template v-slot:btn-prev>
        <div class="scroll-btn scroll-btn-prev">
          <inline-svg :src="require('@/assets/img/icons/icon-arrow-left-chev.svg')" />
        </div>
      </template>
      <template v-slot:btn-next>
        <div class="scroll-btn scroll-btn-next">
          <inline-svg :src="require('@/assets/img/icons/icon-arrow-right-chev.svg')" />
        </div>
      </template>

    </vue-horizontal>
  </div>
</template>

<script>
import VueHorizontal from 'vue-horizontal'
import InlineSvg from 'vue-inline-svg'

export default {
  name: 'QuickFiltersContainer',
  components: {
    VueHorizontal,
    InlineSvg
  },
  data () {
    return {
      rendering: false
    }
  },
  methods: {
    scrollToPosition (position) {
      this.$refs.horizontal.scrollToIndex(position)
      this.$refs.horizontal.refresh()
      this.rendering = true
      this.rendering = false
    }
  },
  mounted () {
    this.$root.$on('refreshQuickFilterContainer', (event) => {
      if (this.$refs?.horizontal) {
        const lastItem = event?.length ? event.length - 1 : 0
        this.scrollToPosition(lastItem)
      }
    })
    this.$root.$on('scrollToSelectedQuickFilter', (event) => {
      if (this.$refs?.horizontal) {
        const indexToScroll = event || 0
        this.scrollToPosition(indexToScroll)
      }
    })
  }

}

</script>

<style lang="scss" scoped>

.scroll-btn {
  width: 24px;
  height: 24px;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;

  &-prev {
    @media screen and (max-width:576px) {
      position: absolute;
      left: -10px;

    }
  }

  &-next {
    @media screen and (max-width:576px) {
      position: absolute;
      right: -3px;

    }
  }

  &>svg {
    width: 16px !important;
    height: 16px !important;
  }

}

.filter-container {
  margin-bottom:16px;
}

.scrollbar-container {

  // max-width: calc(100vw - 120px);
  // position: relative;
  @media screen and (max-width:576px) {
    max-width: calc(100vw - 50px);
    margin: 0px 10px;
  }
}
</style>
<style></style>
